import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";

import "./OtpModal.scss";
import VerifyOtpForm from "./VerifyOtpForm";
import { BsArrowLeft } from "react-icons/bs";

export default function OtpModal({ showModal, handleClose, data }) {
  const handleOtpSubmit = (otpCode) => {
    console.log("submit otp");
  };

  return (
    <Modal animation={false} show={showModal} onHide={handleClose} className="otp_modal">
      <Modal.Header>
        <div className="back_button_wrapper" onClick={handleClose}>
          <BsArrowLeft />
        </div>
      </Modal.Header>
      <Modal.Body>
        <VerifyOtpForm handleOtpSubmit={handleOtpSubmit} data={data} handleClose={handleClose} />
      </Modal.Body>
    </Modal>
  );
}
